<template>
  <div id="app">
    <!-- <RouterView /> -->
    <HomeView></HomeView>
  </div>
</template>

<script>
import HomeView from "./HomeView.vue";
export default {
  name: "App",
  components: {
    HomeView,
  },
};
</script>
